var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
var DevianceValueCheckDirective = /** @class */ (function () {
    function DevianceValueCheckDirective() {
        this.minTime = 0;
    }
    DevianceValueCheckDirective_1 = DevianceValueCheckDirective;
    DevianceValueCheckDirective.prototype.validate = function (control) {
        if (!control.value && control.value !== 0) {
            return { 'delayTime': 'error' };
        }
        var value = +control.value;
        if (value < this.minTime) {
            return { 'delayTime': 'error' };
        }
        return undefined;
    };
    var DevianceValueCheckDirective_1;
    __decorate([
        Input()
    ], DevianceValueCheckDirective.prototype, "minTime", void 0);
    DevianceValueCheckDirective = DevianceValueCheckDirective_1 = __decorate([
        Directive({
            selector: '[devianceValueCheck]',
            providers: [{
                    provide: NG_VALIDATORS,
                    useExisting: DevianceValueCheckDirective_1,
                    multi: true
                }]
        })
    ], DevianceValueCheckDirective);
    return DevianceValueCheckDirective;
}());
export { DevianceValueCheckDirective };
